import './footer.css';

export function Footer() {
    return (
        <div className="footer">
            AI-generated content may contain errors. All information should be independently verified before use. Users are responsible for confirming accuracy. No guarantees of accuracy or completeness are provided.
        </div>
    );
};